import { createContext } from 'react';
import { DashboardController } from './types';

// eslint-disable-next-line
export const DashboardContext = createContext<DashboardController | null>(null);

export type DashboardProviderProps = {
  controller: DashboardController;
};

export function DashboardProvider({
  controller,
  ...others
}: React.PropsWithChildren<DashboardProviderProps>) {
  return <DashboardContext.Provider {...others} value={controller} />;
}

DashboardProvider.displayName = 'DashboardProvider';
